import {Utils} from '@astek/utils';
import {JsonConfigInterface} from './json-config-interface';
import {ColorConfig, ColorConfigJson} from './color-config';
import {BorderConfig, BorderConfigJson} from './border-config';

export type RectangleConfigJson = {
  color: ColorConfigJson;
  border?: BorderConfigJson;
};

export class RectangleConfig implements JsonConfigInterface<RectangleConfigJson> {

  public readonly color: ColorConfig = new ColorConfig();
  public readonly border: BorderConfig = new BorderConfig();

  constructor(json?: RectangleConfigJson) {
    if (!Utils.isNullOrUndefined(json)) {
      this.deserializeJson(json);
    }
  }

  public deserializeJson(json: RectangleConfigJson): void {
    this.color.deserializeJson(json.color);
    this.border.deserializeJson(json.border ?? new BorderConfig());
  }
}
